import translate, { getLangKey } from '@translate';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLocationParams } from 'src/resources/location/reducer';
import FileDisplay from 'src/components/FileDisplay';
import { styled } from '@mui/system';
import { colors, sizes } from 'src/themes/default';
import Typography from 'src/components/Typography';
import Button from 'src/components/Button';
import Stack from '@mui/material/Stack';
import { DetailIcon } from 'src/components/SkladonIcon/Icons';
import downloadFile from 'src/utils/downloadFile';

interface PdfContainerProps {
    spaceBottom?: boolean;
}

const PdfContainer = styled('div')<PdfContainerProps>(({ theme, spaceBottom }) => ({
    backgroundColor: colors.background_LB,
    padding: sizes.button_M_PD,
    border: `1px solid ${colors.background_B3}`,
    marginBottom: spaceBottom ? '16px' : '0px',
    [theme.breakpoints.down('sm')]: {
        marginBottom: '0px'
    }
}));

type PdfBlockPropsType = { file: string; title: string; text: string; url?: string; spaceBottom?: boolean };

const PdfBlock: FC<PdfBlockPropsType> = (props) => {
    const [modal, setModal] = useState(false);

    const displayModal = () => {
        setModal(true);
    };

    const hideModal = () => {
        setModal(false);
    };

    const handleDowloadFile = () => {
        downloadFile(`/pdf/${props.file}`, props.title);
    };

    return (
        <PdfContainer spaceBottom={props.spaceBottom}>
            <div>
                <FileDisplay
                    file={{ data: `/pdf/${props.file}`, fileType: 'application/pdf', directUrl: true }}
                    width={'100%'}
                    height={'175px'}
                    disableModal={!modal}
                    modal={modal}
                    onClose={hideModal}
                />
            </div>
            <div>
                <Typography variant="h3" align="center" sx={{ padding: '20px 0px' }}>
                    {props.title}
                </Typography>
                <Typography variant="body2" align="center" sx={{ marginBottom: '20px', height: '36px' }}>
                    {props.text}
                </Typography>
            </div>
            <Stack spacing={2} direction="row" justifyContent="center">
                {!props.url && (
                    <>
                        <Button variant="outlined" onClick={handleDowloadFile}>
                            {translate('documents.dowload')}
                        </Button>

                        <Button endIcon={<DetailIcon />} onClick={displayModal}>
                            {translate('documents.show')}
                        </Button>
                    </>
                )}
                {!!props.url && (
                    <a href={props.url} target="_blank">
                        <Button endIcon={<DetailIcon />}>{translate('documents.show')}</Button>
                    </a>
                )}
            </Stack>
        </PdfContainer>
    );
};

const DocumentsContainer: FC = () => {
        const dispatch = useDispatch();
        const lang = getLangKey();
        useEffect(() => {
            dispatch(setLocationParams({ name: translate('documents.title') }));
        }, []);

        return (
            <>
                {lang === 'CZ' && (
                    <div>
                        <p>
                            Všechny návody a dokumenty naleznete v naší <strong>Skladon Znalostní databázi</strong>.
                            Pro přesměrování do znalostní báze klikněte na tento <strong><a
                            href="https://skladon.freshdesk.com/support/home"
                            target="_blank"
                            style={{ color: '#E72D61' }}>ODKAZ</a></strong>.</p>
                        <p>
                            Pokud v databázi nenajdete to, co hledáte, nebo pokud narazíte na chybné informace, dejte nám
                            prosím
                            vědět. Rádi vše doplníme či opravíme.
                        </p>
                    </div>)}
                {lang === 'EN' && (
                    <div>
                        <p>
                            All manuals and documents can be found in our <strong>Skladon Knowledge Base</strong>. Click on
                            this <strong><a
                            href="https://skladon.freshdesk.com/support/home" target="_blank"
                            style={{ color: '#E72D61' }}>LINK</a></strong> to be redirected to
                            the knowledge base.</p>
                        <p>
                            If you don't find what you are looking for, or you find incorrect information in the Knowledge Base,
                            please let us know. We will be happy to add anything or correct it.
                        </p>
                    </div>
                )}
            </>
        )
            ;
    }
;

export default DocumentsContainer;
